import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-exclamation-circle" }, null, -1)
const _hoisted_2 = { class: "doctor-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoctorItem = _resolveComponent("DoctorItem")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("div", null, [
    (!!_ctx.selectedDoctor)
      ? (_openBlock(), _createBlock(_component_DoctorItem, {
          key: 0,
          doctor: _ctx.selectedDoctor,
          isDefaultDetail: _ctx.state.isDetail
        }, _createSlots({ _: 2 }, [
          (_ctx.state.isProfile)
            ? {
                name: "desc",
                fn: _withCtx(() => [
                  _createVNode("span", {
                    class: "description-more -medium -royalBlue",
                    onClick: _cache[1] || (_cache[1] = 
            (event) =>
              _ctx.opToggle(
                event,
                !!_ctx.selectedDoctor ? _ctx.selectedDoctor.Profiles.valueOf() : ''
              )
          )
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.t('show detail profile')) + " ", 1),
                    _hoisted_1
                  ])
                ])
              }
            : undefined,
          (_ctx.state.isFavorit)
            ? {
                name: "favorites",
                fn: _withCtx(() => [
                  _createVNode("div", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFavorites && _ctx.toggleFavorites(...args)))
                  }, [
                    _createVNode("img", {
                      class: 
              _ctx.selectedDoctor.MyDoctor === 0
                ? 'star'
                : 'star-fill'
            
                    }, null, 2)
                  ])
                ])
              }
            : undefined,
          (_ctx.$slots.button)
            ? {
                name: "button",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "button")
                ])
              }
            : (_ctx.$slots.detail)
              ? {
                  name: "detail",
                  fn: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "detail")
                  ])
                }
              : undefined
        ]), 1032, ["doctor", "isDefaultDetail"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      showCloseIcon: true,
      ref: "op$"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.descMore.split('\n'), (p, i) => {
            return (_openBlock(), _createBlock("span", { key: i }, _toDisplayString(p), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 512)
  ]))
}